var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.currentRow ? _vm.$t("编辑") : _vm.$t("新增"),
      visible: _vm.dialogVisible,
      okText: _vm.$t("确认"),
      cancelText: _vm.$t("取消"),
      width: 620
    },
    on: {
      ok: _vm.handleSure,
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_c("a-form-model", {
    ref: "userFrom",
    attrs: {
      model: _vm.userFrom,
      rules: _vm.userRule,
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      prop: "nickName",
      label: _vm.$t("管理员名称")
    }
  }, [_c("a-input", {
    model: {
      value: _vm.userFrom.nickName,
      callback: function ($$v) {
        _vm.$set(_vm.userFrom, "nickName", $$v);
      },
      expression: "userFrom.nickName"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "account",
      label: _vm.$t("管理员账号")
    }
  }, [_c("a-input", {
    attrs: {
      maxLength: 50
    },
    on: {
      input: function ($event) {
        return _vm.handleBlurTrim("account");
      }
    },
    model: {
      value: _vm.userFrom.account,
      callback: function ($$v) {
        _vm.$set(_vm.userFrom, "account", $$v);
      },
      expression: "userFrom.account"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("手机号"),
      prop: "mobile"
    }
  }, [_c("a-input", {
    on: {
      input: function ($event) {
        _vm.userFrom.mobile = _vm.userFrom.mobile.replace(/[^\d]/g, "");
      }
    },
    scopedSlots: _vm._u([{
      key: "addonBefore",
      fn: function () {
        return [_c("a-select", {
          staticStyle: {
            width: "90px"
          },
          attrs: {
            "option-label-prop": "value",
            dropdownClassName: "mul-select-dropdown",
            dropdownMenuStyle: {
              width: "180px"
            }
          },
          on: {
            change: _vm.changeGlobalRoaming
          },
          model: {
            value: _vm.userFrom.globalRoaming,
            callback: function ($$v) {
              _vm.$set(_vm.userFrom, "globalRoaming", $$v);
            },
            expression: "userFrom.globalRoaming"
          }
        }, _vm._l(_vm.globalRoamingOptionData, function (item) {
          return _c("a-select-option", {
            key: item.label,
            attrs: {
              value: item.label,
              title: item.label + _vm.$t(item.value)
            }
          }, [_vm._v(_vm._s(item.label) + "  " + _vm._s(_vm.$t(item.value)))]);
        }), 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.userFrom.mobile,
      callback: function ($$v) {
        _vm.$set(_vm.userFrom, "mobile", $$v);
      },
      expression: "userFrom.mobile"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("邮箱"),
      prop: "email"
    }
  }, [_c("a-input", {
    on: {
      input: function ($event) {
        return _vm.handleBlurTrim("email");
      }
    },
    model: {
      value: _vm.userFrom.email,
      callback: function ($$v) {
        _vm.$set(_vm.userFrom, "email", $$v);
      },
      expression: "userFrom.email"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "password",
      label: _vm.$t("登录密码")
    }
  }, [_c("a-input", {
    attrs: {
      maxLength: 16
    },
    on: {
      input: function ($event) {
        _vm.userFrom.password = _vm.userFrom.password.replace(/\s/g, "");
      }
    },
    model: {
      value: _vm.userFrom.password,
      callback: function ($$v) {
        _vm.$set(_vm.userFrom, "password", $$v);
      },
      expression: "userFrom.password"
    }
  })], 1), _vm.userFrom.isSuper != 1 ? _c("a-form-model-item", {
    attrs: {
      prop: "roleId",
      label: _vm.$t("选择角色")
    }
  }, [_c("a-checkbox-group", {
    model: {
      value: _vm.userFrom.roleId,
      callback: function ($$v) {
        _vm.$set(_vm.userFrom, "roleId", $$v);
      },
      expression: "userFrom.roleId"
    }
  }, _vm._l(_vm.roleList, function (item) {
    return _c("a-checkbox", {
      key: item.id,
      attrs: {
        value: item.id,
        name: "type"
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1)], 1) : _vm._e(), _c("a-form-model-item", {
    attrs: {
      prop: "appointCustomerId",
      label: _vm.$t("选择指定客户")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("客户"),
      allowClear: "",
      "show-search": "",
      "option-filter-prop": "children",
      "filter-option": _vm.filterOption,
      mode: "multiple"
    },
    model: {
      value: _vm.customerIdArr,
      callback: function ($$v) {
        _vm.customerIdArr = $$v;
      },
      expression: "customerIdArr"
    }
  }, _vm._l(_vm.customerList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id
      }
    }, [_c("div", {
      staticStyle: {
        display: "flex"
      }
    }, [item.mark ? _c("div", [_vm._v(_vm._s(item.mark) + "/")]) : _vm._e(), _vm._v(" " + _vm._s(item.name) + " ")])]);
  }), 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };